<template>
    <div>
        <span class="data-label">
            <div class="ellipsis">{{ forceLabel ? forceLabel : label }}</div>
            <i
                v-if="useFavorite"
                :class="['blue ml-2 fs-2 cpointer data-label-icon-toggle', isFavoriteClass]"
                @click.prevent="toggleFavorite"
            ></i>
            <i
                v-if="canRemoveFavorite"
                class="icon-close primary-50 ml-2 fs-2 cpointer"
                @click.prevent="toggleFavorite"
            ></i>
        </span>
        <span :class="['data-value copy-element', canRemoveFavoriteClass]">
            {{ days }}
            <clipboard :data="date" />
        </span>
    </div>
</template>

<script>
import FavoriteHeaderMixins from '../../../../mixins/FavoriteHeaderMixins';
import DataValueMixin from '../../../../mixins/DataValueMixins';
import Clipboard from 'vcomponents/utilities/Clipboard.vue';

export default {
    components: {
        Clipboard,
    },
    mixins: [FavoriteHeaderMixins, DataValueMixin],
    computed: {
        days() {
            let nb = moment().diff(moment(this.value), 'days');
            return nb == 0
                ? this.$l10n.__("Aujourd'hui")
                : this.$l10n.n__('%d jour', '%d jours', nb, nb);
        },
        date() {
            return moment(this.value).format('LL');
        },
    },
};
</script>

<style scoped>
.data-label {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>
